import { useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useCreateFiles } from '@tribeplatform/react-sdk/hooks';
import { useI18n } from '../../i18n';
import { findNode } from '../helpers/node';
import { fileUploadError } from '../utils/errors';
import { getFileInfo } from '../utils/file-info';
export const useAddAttachmentToEditor = ({ editor }) => {
    const intl = useI18n();
    const { mutateAsync: createFiles } = useCreateFiles();
    const addAttachment = useCallback(async (file) => {
        var _a, _b, _c;
        const { name, size } = file;
        const { extension, contentType } = getFileInfo(file);
        const tempAttachmentData = {
            id: uuidv4(),
            url: '',
            downloadUrl: '',
            size,
            extension: name.slice(name.lastIndexOf('.') + 1).toLowerCase(),
            name,
            isLoading: true,
        };
        editor
            .chain()
            .focus()
            .setAttachment({
            attachment: tempAttachmentData,
        })
            .setTextSelection(editor.state.selection.anchor) // to reset the selection
            .run();
        try {
            const [uploadedFile] = await createFiles([
                {
                    file,
                    contentType,
                    name,
                    extension,
                    size,
                },
            ]);
            const { offset, node } = findNode(editor.state, node => { var _a; return ((_a = node === null || node === void 0 ? void 0 : node.attrs.attachment) === null || _a === void 0 ? void 0 : _a.id) === tempAttachmentData.id; });
            editor
                .chain()
                .setNodeSelection(offset)
                .focus()
                .setAttachment({
                attachment: uploadedFile,
            })
                .setTextSelection(offset + node.nodeSize)
                .insertContent(' ')
                .run();
        }
        catch (error) {
            // Show the error notification message
            fileUploadError(intl)({
                fileName: file.name,
                message: ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message) || error.message,
            });
            if (tempAttachmentData.id) {
                const { offset } = findNode(editor.state, node => { var _a; return ((_a = node === null || node === void 0 ? void 0 : node.attrs.attachment) === null || _a === void 0 ? void 0 : _a.id) === tempAttachmentData.id; });
                // Delete the actual node (image/video tag) from the DOM
                editor.commands.deleteRange({
                    from: offset,
                    to: offset + 1,
                });
            }
        }
    }, [editor, createFiles, intl]);
    return {
        addAttachment,
    };
};
//# sourceMappingURL=useAddAttachmentToEditor.js.map